<svg><use [attr.href]="href" /></svg>
